import React, { useState, useRef } from "react";
import { FcCalendar, FcClock, FcDownload } from "react-icons/fc";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getFunctions, httpsCallable } from "firebase/functions";
import { auth, db } from "../../config/firebase-config";
import { diffWords } from "diff";

import {
  BiChevronRight,
  BiChevronUp,
  BiDownload,
  BiEdit,
  BiSave,
  BiSearch,
} from "react-icons/bi";
import {
  doc,
  setDoc,
} from "firebase/firestore";
import { toast } from "react-toastify";
import gmeet from "../../images/gmeet.png";
import { AiFillStar, AiOutlineFileSync } from "react-icons/ai";
import { IoClose, IoMail } from "react-icons/io5";
import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import Button from "../../shared/Button/Button";
import { FaEye, FaFileDownload, FaUsers } from "react-icons/fa";
import TranscriptModal from "../../components/TranscriptModal/TranscriptModal";
import cube from "../../images/cube.gif";
import { theme } from "../../utils/theme";
import { RiClipboardLine } from "react-icons/ri";
// import { findAllByAltText } from "@testing-library/react";
import { setCalendarMeetings } from "../../redux/actions/meetingsActions";
// import { grey } from "@mui/material/colors";
import {
  updateRecordingStatus,
  getTranscribeAndSummarize,
  getUniversalInsights,
  getVideoUrl,
} from "../../functions";
import ReactPlayer from "react-player";
import Loader from "./../../components/Popups/Loader";
import { partialUpdateUser, getCurrentUser } from "../../services/UserService"
import { 
  partialUpdateUserCalendarMeetings,
  getUserCalendarMeetings,
  deleteUserCalendarMeetings
} from "../../services/UserCalendarMeetingService"
import { sendNotesByEmail } from "../../services/CommonService";
import { languageOptions } from '../../config/Constants'
import { getBotStatus } from "../../functions";
//
//Start
//
const CalendarMeetingCard = ({ data, pastMeeting, fetchTabMeetings }) => {
  console.log("Data of Calendar: ", data);
  const dispatch = useDispatch();
  const searchTerm = useSelector(
    (state) => state.searchReducer.searchTerm || ""
  );
  const functions = getFunctions();
  const { userData } = useSelector((state) => state.authReducer);
  const { uid } = useSelector((state) => state.authReducer);
  const { calendarMeetings } = useSelector((state) => state.meetingsReducer);
  const audioPlayerRef = useRef(null);
  const [videoOpen, setVideoOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  // const updateRecordingStatus = httpsCallable(
  //   functions,
  //   "updateRecordingStatus"
  // );
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [matchFound, setMatchFound] = useState(false);
  // const [willRecord, setWillRecord] = useState(data?.willRecord || false);
  const [willRecord, setWillRecord] = useState(data?.willRecord);
  // const [controlRefresh, setControlRefresh] = useState(true);
  const [meetName, setMeetName] = useState({
    name: data?.name || "",
    editing: false,
  });
  const [meetSummary, setMeetSummary] = useState({
    summary: data?.summary || "",
    editing: false,
  });
  const [transcriptEditing, setTranscriptEditing] = useState(false);
  const [showFindReplace, setShowFindReplace] = useState(false);

  const [findText, setFindText] = useState("");
  const [replaceText, setReplaceText] = useState("");

  const meetSummaryRef = useRef(null);
  const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });
  // const [focusTextarea, setFocusTextarea] = useState(false);
  const copyToClipboardRef = useRef(null);
  const meetNameRef = useRef(null);
  const [hashTag, setHashTag] = useState({
    name: data?.hashTag || "#CalendarMeet",
    editing: false,
  });
  const [meetQuestion, setMeetQuestion] = useState([]);
  const [meetTask, setMeetTask] = useState({
    task: "",
    editing: false,
  });
  const [meetNote, setMeetNote] = useState({});
  const [meetTaskForOthers, setMeetTaskForOthers] = useState({
    task: "",
    editing: false,
  });
  const hashTagRef = useRef(null);
  const [favourite, setFavourite] = useState(!!data?.favourite);
  
  const [language, setLanguage] = useState();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(data?.rating || 0);
  const [star, setStar] = useState(0);
  const [transcriptOpen, setTranscriptOpen] = useState(false);
  const [transcriptLoading, setTranscriptLoading] = useState(false);
  const [transcriptModal, setTranscriptModal] = useState(false);
  const [transcript, setTranscript] = useState();
  const [showReProcess, setShowReProcess] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [transcriptContent, setTranscriptContent] = useState(null);
  const [currentMessage, setCurrentMessage] = useState(0);
  // const [transcriptSaved, setTranscriptSaved] = useState(false);
  const getTranscriptContent = httpsCallable(functions, "getTranscriptContent");
  const getTranscriptFromBot = httpsCallable(
    functions,
    "getTranscriptFromBot",
    { timeout: 540000 }
  );

  const arabicTranscriptionUsingBotId = httpsCallable(
    functions,
    "arabicTranscriptionUsingBotId",
    { timeout: 540000 }
  );

  const multilingualTranscriptionFromBotId = httpsCallable(
    functions,
    "multilingualTranscriptionFromBotId",
    { timeout: 540000 }
  );

  const getData = httpsCallable(functions, "getData", { timeout: 540000 });
  const getDataHindi = httpsCallable(functions, "getDataHindi", {
    timeout: 540000,
  });
  const getDataArabic = httpsCallable(functions, "getDataArabic", {
    timeout: 540000,
  });
  const getDataMultiLang = httpsCallable(functions, "getDataMultiLang", {
    timeout: 540000,
  });
  const increaseMeetingMinutes = httpsCallable(
    functions,
    "increaseMeetingMinutes"
  );
  const transliterate = httpsCallable(functions, "transliterate", {
    timeout: 540000,
  });
  const [participants, setParticipants] = useState();
  const [participant, setParticipant] = useState();
  const [fileId, setFileId] = useState();
  const [transcript_link, setTranscript_link] = useState();
  const getParticipants = httpsCallable(functions, "getParticipants");
  const [transliteration, setTransliteration] = useState(false);
  const [languagesArray, setLanguagesArray] = useState([]);

  const [sendMailModal, setSendMailModal] = useState(false);
  const [email, setEmail] = useState("");
  const sendMail = httpsCallable(functions, "sendMail");
  const emailRegex = new RegExp(
    "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
  );
  function isValidEmailList(emailList) {
    const trimmedEmailList = emailList.trim();
    if (emailRegex.test(trimmedEmailList)) {
      return true;
    }
    if (trimmedEmailList.includes(",")) {
      const emails = trimmedEmailList.split(",");
      for (let i = 0; i < emails.length; i++) {
        const email = emails[i].trim();
        if (!emailRegex.test(email)) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  const [idx, setIdx] = useState();
  useEffect(() => {
    if (Array.isArray(calendarMeetings)) {
      calendarMeetings.forEach((meet, x) => {
        if (data.id === meet.id) setIdx(x);
      });
    }
  }, [calendarMeetings]);

  const fetchLanguages = async () => {
    let user = getCurrentUser();
    if (userData) {
      const subscriptionData = userData?.subscription || {};
      const languagesArray = subscriptionData?.[Object.keys(subscriptionData)[0]]?.languages || [];

        
        const additionalParameter = Object.keys(subscriptionData)[0];

        const subscriptionName = Object.keys(subscriptionData)[0];
        // console.log("subscriptionName: ", subscriptionName);
        const currentDate = Math.floor(new Date().getTime() / 1000);
        const endDate = subscriptionData?.[additionalParameter]?.periodEnd;
        if (
          (subscriptionName === "productivity pro" ||
            subscriptionName === "business") &&
          endDate >= currentDate
        ) {
          setShowEdit(true);
        }
      return languagesArray;
    } else {
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const languages = await fetchLanguages();
      setLanguagesArray(languages);
    };

    fetchData();
  }, []);
  //

  //
  useEffect(() => {
    if (
      !data?.transliterationAvailable &&
      data?.language === "hindi" &&
      transliteration &&
      !loading
    ) {
      toast.info("We are transliterating your summary");
      setLoading(true);
      const summArray = [];
      summArray.push(data?.summary || "");
      transliterate({
        summary: summArray,
        notes: data?.notes?.map((item) => item.name) || [""],
        questions: data?.questions?.map((item) => item.name) || [""],
        tasks: data?.tasks?.map((item) => item.name) || [""],
        tasksForOthers: data?.tasksForOthers?.map((item) => item.name) || [""],
      })
        .then((res) => {
          let newData = res?.data?.transliterated_text;
          if (res?.data?.transliterated_text) {

            let user = getCurrentUser();
            partialUpdateUserCalendarMeetings(user.uid, data.id,
                {
                  transSummary: newData.summary.map((item) => item).join(" "),
                  tasks: data?.tasks?.map((item, i) => {
                    return { ...item, transName: newData?.tasks[i] };
                  }),
                  notes: data?.notes?.map((item, i) => {
                    return { ...item, transName: newData?.notes[i] };
                  }),
                  questions: data?.questions?.map((item, i) => {
                    return { ...item, transName: newData?.questions[i] };
                  }),
                  tasksForOthers: data?.tasksForOthers?.map((item, i) => {
                    return { ...item, transName: newData?.tasksForOthers[i] };
                  }),
                  transliterationAvailable: true,
                },
                (response) => {
                  fetchTabMeetings()
                    .then(() => {
                      setLoading(false);
                      toast.success("Transliteration is ready");
                    })
                    .catch(() => {
                      setLoading(false);
                      toast.error("Some error occured, try later");
                    });
                },
                (error) => {
                  setLoading(false);
                  toast.error("Some error occured, try later");
                }
            )
          }
        })
        .catch(() => {
          setLoading(false);
          toast.error("Some error occured, try later");
        });
    }
  }, [transliteration]);

  const getMeetingSeconds = (data) => {
    let startTime = moment(data?.startTime)?.toDate();
    let startFound = false;
    data?.botStatus?.history.forEach((history) => {
      if (history?.code === "in_call_recording" && !startFound) {
        startTime = moment(history.created_at).toDate();
        startFound = true;
      }
    });

    const endTime = moment(data?.botStatus?.history[data?.botStatus?.history?.length - 1].created_at)?.toDate();
    return moment(endTime).diff(startTime, "seconds");
  };

  const deleteThisMeetAndDuplicates = async () => {
    let user = getCurrentUser();
    deleteUserCalendarMeetings(user.uid, data?.id,
      (response) => {
        fetchTabMeetings();
      }, (error) => {
        console.warn(`ERROR: ${error}`);
      }
    );
  };

  const getTranscript = async (props) => {
    if (language === "arabic") {
      const transcript = await arabicTranscriptionUsingBotId({
        bot_id: props.botId,
      });
      // console.log(transcript.data.transcript_link, "transcript");
      setTranscript(transcript.data.transcript_link);
      return transcript.data.transcript_link;
    } else if (language === "multi_ar_en_hi" || language === "multi_en_hi") {
      const transcript = await multilingualTranscriptionFromBotId({
        bot_id: props.botId,
      });
      // console.log(transcript.data.transcript_link, "transcript");
      setTranscript(transcript.data.transcript_link);
      return transcript.data.transcript_link;
    } else {
      const transcript = await getTranscriptFromBot({
        bot_id: props.botId,
        language: props.language,
      });
      // console.log(transcript.data.transcript_link, "transcript");
      setTranscript(transcript.data.transcript_link);
      return transcript.data.transcript_link;
    }
  };

  const showBotStatus = (history) => {
    const code = history[history.length - 1].code;
    if (code === "ready") toast.success("The bot is ready to join the meeting");
    if (code === "joining_call") toast.info("The bot is joining the call");
    if (code === "in_waiting_room")
      toast.info("The bot is in the waiting room");
    if (code === "in_call_not_recording")
      toast.info(
        "The bot has joined the meeting, however is not recording yet"
      );
    if (code === "in_call_recording")
      toast.info(
        "The bot is in the meeting, and is currently recording the audio and video"
      );
    if (code === "call_ended") toast.info(history[history.length - 1].message);
    if (code === "done") toast.info("The bot has shut down/meeting over");
    if (code === "fatal")
      toast.info(
        "The bot has encountered an error that prevented it from joining the call"
      );
  };

  const setBotStatus = async (meeting) => {
    console.log("entered", data?.botStatus);

    if (data?.botStatus?.history?.find((x) => x.code === "done")) {
      showBotStatus(data?.botStatus?.history);
    } else {
      getBotStatus({ bot_id: meeting?.botId }, (response) => {
        let botStatusData = response.data;
        let status = {
          ...botStatusData,
          history: botStatusData?.history.map((item) => {
            return {
              code: item.code,
              created_at: moment(item.created_at).toDate(),
              message: item.message,
              sub_code: item.sub_code,
            };
          }),
        };
        showBotStatus(status.history);
        let user = getCurrentUser();
        partialUpdateUserCalendarMeetings(user.uid, meeting.id, { botStatus: status },
            (response) => {
              fetchTabMeetings();
            },
            (error) => {
                console.log("error: ", error);
            }
        )
      }, (error) => {

      })
    }
  };

  const handleSummarizeUsingTranscription = async (transcript) => {
    setLoading(true);
    toast.info("Summary is being generated, Please wait...");
    const formatedTranscript = transcript.replace(/\n/g, "\\n");
    // console.log("formatedTranscript - ", formatedTranscript);

    try {
      getUniversalInsights({
        transcript_vtt: formatedTranscript,
        participant: userData?.name,
      }).then(async (response) => {
        console.log("res - ", response);

        let user = getCurrentUser();
        await partialUpdateUserCalendarMeetings(user.uid, data.id,
          {
            summary: response?.summary,
            notes: response?.important_points.map((note) => ({
              completed: false,
              name: note,
            })),
            questions: response?.questions.map((question) => ({
              completed: false,
              name: question,
            })),
            tasks: response?.action_items_user.map((task) => ({
              completed: false,
              name: task,
            })),
            tasksForOthers: response?.action_items_others.map((task) => ({
              completed: false,
              name: task,
            })),
          },
          (response) => {
            toast.success("New Summary is generated!");
            setLanguage(null);
            setLoading(false);
            setOpen(true);
            partialUpdateUser(user.uid, data.id,
              {
                previouslySavedTranscript: data.generatedTranscript,
                reProcessLimit: false,
              },
              (response) => {
                setShowReProcess(false);
                fetchTabMeetings();
              }
            )
          }
        )
      });
    } catch (error) {
      console.error("Error in getUniversalInsights - ", error);
      toast.error("Something went wrong, Please try again!");
    }
  };

  const handleTranscribeAndSummarize = async () => {
    setLoading(true);
    try {
      // Get the document ID
      let user = getCurrentUser();
      return getUserCalendarMeetings(user.uid, data.id,
          async(response) => {
            const documentSnap = response.data;
            const documentID = documentSnap.id;

            // Check if language is selected
            if (!language) {
              toast.info("Please select a language.");
              setLoading(false);
              return;
            }

            // Call your API function with the document ID and selected language
            console.log(data.botId, uid, language, documentID);
            await getTranscribeAndSummarize({
              bot_id: data.botId,
              user_id: uid,
              internal_language_code: language,
              document_id: documentID,
              meeting_collection: "calendarMeetings",
            });
            setOpen(true);
            fetchTabMeetings();
            setLanguage(null);
          },
          (error) => {
            setLanguage(null);
            toast.error("Error processing the request.");
          }
      )
    } catch (error) {
      console.error("Error fetching document ID or calling API:", error);
      setLanguage(null);
      toast.error("Error processing the request.");
    } finally {
      setLoading(false);
      setLanguage(null);
    }
  };

  const handleReProcessClick = (language) => {
    setLanguage(userData?.defaultLanguage);
  };

  const getInsights = async (props) => {
    console.log(props, "kdnaskn");
    let res;
    if (props.language === "english") {
      res = await getData({
        file_id: props.file_id,
        participant: props.participant,
      });
    } else if (props.language === "hindi") {
      res = await getDataHindi({
        file_id: props.file_id,
        participant: props.participant,
      });
    } else if (
      props.language === "arabic" ||
      props.language === "multi_ar_en_hi" ||
      props.language === "multi_en_hi"
    ) {
      console.log("Entered Arabic || Entered MultiLang");
      // console.log("Transcript URL -", props.data.url);
      // console.log("TransURL-", data.url);
      const tURL = data.url;
      res = await getDataArabic({
        transcript_link: tURL,
        participant: props.participant,
      });
    } else {
      console.log("Entered multilang");
      res = await getDataMultiLang({
        file_id: props.file_id,
        participant: props.participant,
        language: props.language,
      });
    }
    if (res.data?.result) {
      if (res.data.result.message === "completed") {
        const insights = JSON.parse(res.data.result.body);

        const newdata = {
          summary: insights?.summary,
          questions: insights?.questions?.map((item) => {
            return {
              completed: false,
              name: item,
            };
          }),
          notes: insights?.notes?.map((item) => {
            return {
              completed: false,
              name: item,
            };
          }),
          tasks: insights?.useractionitem?.map((item) => {
            return {
              completed: false,
              name: item,
              taskDone: false,
              taskDeleted: false,
            };
          }),
          tasksForOthers: insights?.otheractionitem?.map((item) => {
            return {
              completed: false,
              name: item,
            };
          }),
        };
        await setDoc(
          doc(
            db,
            `users/${localStorage.getItem("@auth")}/calendarMeetings/${data.id}`
          ),
          newdata,
          { merge: true }
        );
        increaseMeetingMinutes({
          seconds: getMeetingSeconds(),
          uid: localStorage.getItem("@auth"),
        });
        sendMail({
          email: auth.currentUser.email,
          meetName: data?.name || "(Meet name not provided)",
          name: auth.currentUser.displayName + " (yourself)",
          summary: newdata?.summary,
          notes: newdata?.notes?.map((item) => item.name),
          questions: newdata?.questions?.map((item) => item.name),
          tasks: newdata?.tasks?.map((item) => item.name),
          tasksForOthers: newdata?.tasksForOthers?.map((item) => item.name),
        });
      } else if (res.data.result.message === "processing") {
        toast.info(
          "We have a pending processing request for the same transcript, try later..."
        );
      } else {
        toast.error("Couldn't generate insights for this transcript");
      }
    } else {
      if (res.data.message === "completed") {
        const insights = JSON.parse(res.data.body);
        const newdata = {
          summary: insights?.summary,
          questions: insights?.questions?.map((item) => {
            return {
              completed: false,
              name: item,
            };
          }),
          notes: insights?.notes?.map((item) => {
            return {
              completed: false,
              name: item,
            };
          }),
          tasks: insights?.useractionitem?.map((item) => {
            return {
              completed: false,
              name: item,
              taskDone: false,
              taskDeleted: false,
            };
          }),
          tasksForOthers: insights?.otheractionitem?.map((item) => {
            return {
              completed: false,
              name: item,
            };
          }),
        };
        await setDoc(
          doc(
            db,
            `users/${localStorage.getItem("@auth")}/calendarMeetings/${data.id}`
          ),
          newdata,
          { merge: true }
        );
        increaseMeetingMinutes({
          seconds: getMeetingSeconds(),
          uid: localStorage.getItem("@auth"),
        });
        sendMail({
          email: auth.currentUser.email,
          meetName: data?.name || "(Meet name not provided)",
          name: auth.currentUser.displayName + " (yourself)",
          summary: newdata?.summary,
          notes: newdata?.notes?.map((item) => item.name),
          questions: newdata?.questions?.map((item) => item.name),
          tasks: newdata?.tasks?.map((item) => item.name),
          tasksForOthers: newdata?.tasksForOthers?.map((item) => item.name),
        });
      } else if (res.data.message === "processing") {
        toast.info(
          "We have a pending processing request for the same transcript, try later..."
        );
      } else {
        toast.error("Couldn't generate insights for this transcript");
      }
    }
    setParticipant(null);
    setParticipants(null);
    setLanguage(null);
  };

  const getStartTime = () => {
    // console.log("data?.startTime?.toDate()", data?.startTime?.toDate());
    let startTime = moment(data?.startTime)?.toDate();
    let startFound = false;
    data?.botStatus?.history.forEach((history) => {
      if (history?.code === "in_call_recording" && !startFound) {
        startTime = moment(history.created_at).toDate();
        startFound = true;
      }
    });
    return startTime;
  };

  const handleSave = async () => {
    try {
      // Update the Firestore document
      console.log("Meet Name to be saved:", meetName.name);
      let user = getCurrentUser();
      await partialUpdateUserCalendarMeetings(user.uid, data.id, { name: meetName.name })
      
      // Update local state and Redux state
      const newCalData = [...calendarMeetings];
      newCalData[idx] = { ...newCalData[idx], name: meetName.name };

      dispatch(setCalendarMeetings(newCalData));

      // Display a success message
      toast.success("Meet Name Saved!");
    } catch (error) {
      console.error("Error saving meet name to Firestore:", error);
      // Handle error, display an error message, etc.
    }
  };

  const checkAndSetReProcess = async () => {
    const reProcessLimitValue = data?.reProcessLimit;
    if (reProcessLimitValue) {
      setShowReProcess(true);
    } else {
      setShowReProcess(false);
    }
    // let user = getCurrentUser();
    // getUserCalendarMeetings(user.uid, data.id,
    //     (response) => {
    //       const data = response.data;
    //       const reProcessLimitValue = data?.reProcessLimit;
    //       if (reProcessLimitValue) {
    //         setShowReProcess(true);
    //       } else {
    //         setShowReProcess(false);
    //       }
    //     },
    //     (error) => {
    //         console.log("error: ", error);
    //     }
    // )
  };

  useEffect(() => {
    checkAndSetReProcess();
  }, []);

  //double click start

  const handleDoubleClick = (e) => {
    const { clientX, clientY } = e;
    setClickPosition({ x: clientX, y: clientY });

    setMeetSummary((val) => {
      return { ...val, editing: true };
    });

    setTimeout(() => {
      if (meetSummaryRef.current) {
        meetSummaryRef.current.focus();
        meetSummaryRef.current.style.height = `${meetSummaryRef.current.scrollHeight}px`;
        meetSummaryRef.current.setSelectionRange(
          meetSummaryRef.current.value.length,
          meetSummaryRef.current.value.length
        ); // Set the cursor at the end
      }
    }, 0);
  };

  const handleNoteDoubleClick = (index, item) => {
    setMeetNote((prevMeetNote) => ({
      ...prevMeetNote,
      [index]: {
        ...prevMeetNote[index],
        name: item.name,
        editing: true,
      },
    }));

    setTimeout(() => {
      const inputElement = document.getElementById(`note-input-${index}`);
      if (inputElement) {
        inputElement.focus();
        inputElement.style.height = `${inputElement.scrollHeight}px`;
        inputElement.setSelectionRange(
          inputElement.value.length,
          inputElement.value.length
        );
      }
    }, 0);
  };

  const handleTaskDoubleClick = (index, item) => {
    setMeetTask((prevMeetTask) => ({
      ...prevMeetTask,
      [index]: {
        ...prevMeetTask[index],
        name: item.name,
        editing: true,
      },
    }));

    setTimeout(() => {
      const inputElement = document.getElementById(`task-input-${index}`);
      if (inputElement) {
        inputElement.focus();
        inputElement.style.height = `${inputElement.scrollHeight}px`;
        inputElement.setSelectionRange(
          inputElement.value.length,
          inputElement.value.length
        );
      }
    }, 0);
  };

  const handleQuestionDoubleClick = (index, item) => {
    setMeetQuestion((prevMeetQuestion) => ({
      ...prevMeetQuestion,
      [index]: {
        ...prevMeetQuestion[index],
        name: item.name,
        editing: true,
      },
    }));

    setTimeout(() => {
      const inputElement = document.getElementById(`question-input-${index}`);
      if (inputElement) {
        inputElement.focus();
        inputElement.style.height = `${inputElement.scrollHeight}px`;
        inputElement.setSelectionRange(
          inputElement.value.length,
          inputElement.value.length
        );
      }
    }, 0);
  };

  const handleTaskForOthersDoubleClick = (index, item) => {
    setMeetTaskForOthers((prevMeetTaskForOthers) => ({
      ...prevMeetTaskForOthers,
      [index]: {
        ...prevMeetTaskForOthers[index],
        name: item.name,
        editing: true,
      },
    }));

    setTimeout(() => {
      const inputElement = document.getElementById(
        `taskForOthers-input-${index}`
      );
      if (inputElement) {
        inputElement.focus();
        inputElement.style.height = `${inputElement.scrollHeight}px`;
        inputElement.setSelectionRange(
          inputElement.value.length,
          inputElement.value.length
        );
      }
    }, 0);
  };

  //double click end

  const handleVideoButtonClick = async (botId) => {
    // console.log("botID - ", botId);

    try {
      const response = await getVideoUrl(botId);
      // console.log("response - ", response);
      const responseData = response?.data;
      return responseData;
    } catch (error) {
      console.error("Error fetching video URL:", error);
      return null;
    }
  };

  const formatConversation = (transcript) => {
    const lines = transcript.split("\n");
    let conversation = [];

    let currentMessage = null;

    for (const line of lines) {
      if (line.trim() === "") {
        // Skip empty lines
        continue;
      }

      if (line.includes("-->")) {
        // New timestamp line
        if (currentMessage) {
          // Add the previous message to the conversation
          conversation.push(currentMessage);
        }

        // Initialize a new message
        const timeStamp = line.split(" --> ")[0].trim();
        currentMessage = {
          timeStamp,
          participant: "",
          text: "",
        };
      } else if (line.includes("<v ")) {
        // Extract participant name and text content
        const regex = /<v\s*([^>]+)>(.*?)<\/v>/;
        const match = line.match(regex);

        if (match) {
          currentMessage.participant = match[1].trim();
          currentMessage.text += match[2].trim() + " ";
        }
      }
    }

    // Add the last message to the conversation
    if (currentMessage) {
      conversation.push(currentMessage);
    }

    // console.log("conversation - ", conversation);
    return conversation;
  };

  useEffect(() => {
    if (transcriptOpen && !transcriptContent && data?.url) {
      setTranscriptLoading(true);
      getTranscriptContent({ url: data.url })
        .then((res) => setTranscriptContent(res.data))
        .finally(() => {
          setTranscriptLoading(false);
        });
    } else if (data?.generatedTranscript && !transcriptContent) {
      const formattedConversation = formatConversation(
        data.generatedTranscript
      );
      // console.log("formattedConversation - ", formattedConversation);
      setTranscriptContent(formattedConversation);
    }
  }, [transcriptOpen]);

  const comparingVTT = (string1, string2) => {
    const diffResult = diffWords(string1, string2);
    let changesCount = 0;
    const interchangedWordsSet = new Set();

    diffResult.forEach(({ added, value }) => {
      if (added) {
        const words = value.trim().split(/\s+/);

        words.forEach((word) => {
          if (!interchangedWordsSet.has(word)) {
            interchangedWordsSet.add(word);
            changesCount++;
          }
        });
      }
    });

    const interchangedWords = Array.from(interchangedWordsSet);
    return { changesCount, interchangedWords };
  };

  const handleSaveTranscript = async () => {
    try {
      // Convert the formatted conversation back to WEBVTT format
      const vttContent = `WEBVTT\n\n${transcriptContent
        .map((message, index) => {
          const endTime = message.endTime || getNextMessageStartTime(index);
          return `${message.timeStamp} --> ${endTime}\n<v ${message.participant}>${message.text}</v>`;
        })
        .join("\n\n")}`;

      let user = getCurrentUser();
      partialUpdateUserCalendarMeetings(user.uid, data.id, { generatedTranscript: vttContent },
          async(response) => {
            const formattedConversation = formatConversation(vttContent);
            setTranscriptContent(formattedConversation);
            setTranscriptEditing(false);
            setFindText("");
            setReplaceText("");
            toast.success("Transcript Saved Successfully");
            const string1 = data.previouslySavedTranscript;
            const string2 = vttContent;

            const comparisonResult = comparingVTT(string1.trim(), string2.trim());

            console.log("Changes Count:", comparisonResult.changesCount);
            console.log("Interchanged Words:", comparisonResult.interchangedWords);

            if (comparisonResult.changesCount >= 21) {
              // console.log("Show Re - Process Button");
              setShowReProcess(true);
              await partialUpdateUserCalendarMeetings(user.uid, data.id, { reProcessLimit: true })
            }
          }
      )
    } catch (error) {
      console.error("Error saving transcript:", error);
    }
  };

  const getNextMessageStartTime = (index) => {
    const nextMessage = transcriptContent[index + 1];
    return nextMessage ? nextMessage.timeStamp : "00:00:00.000";
  };

  const handleTextareaChange = (messageIndex, newText) => {
    const updatedTranscript = [...transcriptContent];

    updatedTranscript[messageIndex] = {
      ...updatedTranscript[messageIndex],
      text: newText,
    };

    // Update the transcriptContent state with the edited messages
    setTranscriptContent(updatedTranscript);
  };

  const handleFind = () => {
    const regex = new RegExp(escapeRegExp(findText), "g");
    const match = transcriptContent.match(regex);

    if (match) {
      // Implement logic to handle found text (e.g., highlight or navigate)
      console.log(`Found: ${match.join(", ")}`);
    } else {
      console.log("Text not found.");
    }
  };

  const handleReplaceAll = () => {
    const regex = new RegExp(escapeRegExp(findText), "g");
    const updatedTranscript = transcriptContent.map((message) => ({
      ...message,
      text: message.text.replace(regex, replaceText),
      participant: message.participant.replace(regex, replaceText),
    }));
    setTranscriptContent(updatedTranscript);
  };

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  const highlightText = (text, searchTerm) => {
    if (!searchTerm || !text) {
      return text; // No highlighting needed if searchTerm is empty
    }

    const regex = new RegExp(`(${searchTerm})`, "gi");
    return text
      .split(regex)
      .map((part, index) =>
        regex.test(part) ? <mark key={index}>{part}</mark> : part
      );
  };

  const highlightTranscript = (text, searchTerm) => {
    if (!searchTerm || !text) {
      return text; // No highlighting needed if searchTerm is empty
    }
    const regex = new RegExp(`(${searchTerm})`, "gi");
    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="bg-yellow-200">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const createNewTranscript = async () => {
    console.log("Transcript edit button was clicked");
    // console.log("transcript - ", data?.generatedTranscript);

    if (data?.generatedTranscript) {
      console.log("Entered");
      if (!data.og_transcript && !data.previouslySavedTranscript) {
        // console.log("Not present");
        const copyTranscript = data?.generatedTranscript;
        try {
          await setDoc(
            doc(
              db,
              `users/${localStorage.getItem("@auth")}/calendarMeetings/${
                data.id
              }`
            ),
            {
              og_transcript: copyTranscript,
              previouslySavedTranscript: copyTranscript,
            },
            { merge: true }
          );
        } catch (error) {
          console.error("Error saving transcript:", error);
        }
      }
    }
  };

  return (
    <div
      id={data?.id}
      className=" s12-p1-step border w-full p-[10px] sm:p-[20px] transition rounded-md my-[10px]"
    >
      <Loader isLoading={isLoading} />
      {/* {data?.calendarMeetId} */}
      {/* {data?.id} */}
      <div className=" flex items-center justify-between">
        <div className="flex items-center gap-[10px] text-xs md:text-sm 2xl:text-base flex-wrap ">
          <div className=" s13-step flex items-center justify-between">
            {data?.name ? (
              meetName.editing ? (
                <input
                  ref={meetNameRef}
                  value={meetName.name}
                  onChange={(e) => {
                    setMeetName((val) => ({ ...val, name: e.target.value }));
                  }}
                  className="text-gray-500 outline-none"
                  id="meetName"
                  placeholder="Add Meet Name"
                />
              ) : (
                highlightText(data?.name, searchTerm)
              )
            ) : (
              <input
                ref={meetNameRef}
                disabled={!meetName.editing}
                value={meetName.name}
                onChange={(e) => {
                  setMeetName((val) => ({ ...val, name: e.target.value }));
                }}
                className="text-gray-500 outline-none"
                id="meetName"
                placeholder="Add Meet Name"
              />
            )}
            {meetName.editing ? (
              <BiSave
                onClick={() => {
                  setMeetName((val) => ({ ...val, editing: false }));
                  handleSave(); // Call the handleSave function to save changes
                }}
                title="Save"
                className="ml-[5px] cursor-pointer"
              />
            ) : (
              <BiEdit
                title="Edit"
                className="ml-[5px] cursor-pointer"
                onClick={() => {
                  setMeetName((val) => ({ ...val, editing: true }));
                  meetNameRef.current?.focus();
                }}
              />
            )}
          </div>

          <div className="text-[#07457f] text-xs md:text-sm 2xl:text-base flex items-center gap-[5px]">
            {data?.hashTag ? (
              hashTag.editing ? (
                <input
                  ref={hashTagRef}
                  value={hashTag.name}
                  onChange={(e) => {
                    setHashTag((val) => {
                      return { ...val, name: e.target.value };
                    });
                  }}
                  className="text-[#07457f] text-xs md:text-sm 2xl:text-base outline-none w-[100px]"
                  id="HashTag"
                  placeholder="Add Hashtag"
                />
              ) : (
                data?.hashTag
              )
            ) : (
              <input
                ref={hashTagRef}
                disabled={!hashTag.editing}
                value={hashTag.name}
                onChange={(e) => {
                  setHashTag((val) => {
                    return { ...val, name: e.target.value };
                  });
                }}
                className="text-[#07457f] text-xs md:text-sm 2xl:text-base outline-none w-[100px]"
                id="HashTag"
                placeholder="Add Hashtag"
              />
            )}
            {hashTag.editing ? (
              <BiSave
                onClick={async() => {
                  setHashTag((val) => {
                    return { ...val, editing: false };
                  });

                  let user = getCurrentUser();
                  await partialUpdateUserCalendarMeetings(user.uid, data.id, { hashTag: hashTag.name });
                  const newCalData = calendarMeetings;
                  newCalData[idx] = {
                    ...newCalData[idx],
                    hashTag: hashTag.name,
                  };
                  import("../../redux/actions/meetingsActions")
                    .then((ac) => dispatch(ac.setCalendarMeetings(newCalData)))
                    .then(() => {
                      toast.success("Hash Tag Saved!");
                    });
                }}
                title="Save"
                className="cursor-pointer"
              />
            ) : (
              <BiEdit
                title="Edit"
                className="cursor-pointer"
                onClick={() => {
                  setHashTag((val) => {
                    return { ...val, editing: true };
                  });
                  hashTagRef.current?.focus();
                }}
              />
            )}
          </div>
          <div className="flex items-center gap-[10px]">
            {/* <span className='text-[#07457f]'>#DailyStandups</span> */}
            <AiFillStar
              title="Favourite"
              className={`s21-step text-sm sm:text-base md:text-lg cursor-pointer text-gray-300 hover:text-yellow-400 ${
                favourite && "text-yellow-400"
              }`}
              onClick={async() => {
                setFavourite(!!!data?.favourite);
                let user = getCurrentUser();
                await partialUpdateUserCalendarMeetings(user.uid, data.id, { favourite: !!!data?.favourite });
                const newMeetData = calendarMeetings;
                newMeetData[idx] = {
                  ...newMeetData[idx],
                  favourite: !!!data?.favourite,
                };
                import("../../redux/actions/meetingsActions").then((ac) =>
                  dispatch(ac.setCalendarMeetings(newMeetData))
                );
              }}
            />
          </div>
        </div>
        {(data?.summary ||
          data?.notes?.length ||
          data?.tasks?.length ||
          data?.tasksForOthers?.length ||
          data?.questions?.length) ? (
          <div
            onClick={() => {
              setOpen(!open);
            }}
            className="cursor-pointer flex gap-[5px] items-center text-[#6b7b8a] lg:text-sm text-xs s14-step "
          >
            Details
            <BiChevronUp
              className={`text-black sm:text-xl transition ${
                open ? "rotate-180" : "rotate-90"
              }`}
            />
          </div>
        ): ( <></> ) }
      </div>
      <div className="flex items-start sm:items-center justify-between">
        <div className="flex items-center flex-wrap gap-[15px] my-[10px] text-xs sm:text-sm xl:text-base">
          <div className="flex items-center gap-[5px]">
            <FcCalendar className="h-[22px] w-[22px]" />
            <div className="text-[#19324B]">
              {moment(data?.startTime).format("ddd, MMM DD")}
            </div>
          </div>

          {data?.botStatus?.status !== "done" && (
            <div className="flex items-center gap-[5px]">
              <FcClock className="h-[22px] w-[22px]" />
              <div className="text-[#19324B]">
                {moment(moment(data?.startTime)?.toDate()).format("hh:mm A")} -{" "}
                {moment(moment(data?.endTime)?.toDate()).format("hh:mm A")}
              </div>
            </div>
          )}
          {data?.botStatus?.status === "done" && (
            <div className="flex items-center gap-[5px]">
              <FcClock className="h-[22px] w-[22px]" />
              <div className="text-[#19324B]">
                {moment(getStartTime()).format("hh:mm A")} -{" "}
                {moment(
                  moment(data?.botStatus?.history[
                    data?.botStatus?.history?.length - 1
                  ].created_at)?.toDate()
                ).format("hh:mm A")}
              </div>
            </div>
          )}
          {data?.url && (
            <a href={data?.url} title="Download transcript">
              <FaFileDownload
                style={{ color: theme.color }}
                className="h-[18px] w-[18px nineth-step"
              />
            </a>
          )}
        </div>

        {data?.language === "hindi" && open && (
          <div
            onClick={() => {
              setTransliteration((t) => !t);
            }}
            className={`w-[60px] p-[2px] rounded-full transition flex items-center cursor-pointer shadow-inner ${
              transliteration
                ? "shadow-[#07457f] bg-[#2c74b3] justify-end"
                : "bg-gray-200 shadow-gray-500 justify-start"
            }`}
          >
            <div className="p-[10px] shadow-md shadow-black/40 rounded-full bg-gray-100 border-white border-2 relative flex justify-center items-center">
              {transliteration ? (
                <span className="absolute text-xs">Hi</span>
              ) : (
                <span className="absolute text-xs">हि</span>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="flex">
        {loading && (
          <p
            className="text-xs sm:text-sm xl:text-base"
            style={{ color: theme.color }}
          >
            New Transcription is being generated, Please Wait...
          </p>
        )}
      </div>
      <div className={`w-full ${!open ? "hidden" : "fade"} `}>
        {data?.summary && open && !showEdit && (
          <div className="py-[10px] px-[10px] sm:px-[20px] ">
            <div className="sm:flex sm:flex-row flex-col gap-[10px] items-start s15-step">
              <div className="text-[#6b7b8a] text-sm 2xl:text-base font-semibold min-w-fit">
                Call Summary :{" "}
              </div>
              <div className="text-justify text-sm 2xl:text-base flex-grow">
                {data?.transliterationAvailable && transliteration
                  ? highlightText(data?.transSummary, searchTerm)
                  : highlightText(data?.summary, searchTerm)}
              </div>
            </div>
          </div>
        )}

        {data?.summary && open && showEdit && (
          <div className="py-[10px] px-[10px] sm:px-[20px] ">
            <div className="sm:flex sm:flex-row flex-col gap-[10px] items-start s15-step">
              <div className="text-[#6b7b8a] text-sm 2xl:text-base font-semibold min-w-fit">
                Call Summary :{" "}
              </div>
              <div className="text-justify text-sm 2xl:text-base flex-grow h-auto">
                {meetSummary.editing ? (
                  <textarea
                    ref={meetSummaryRef}
                    value={meetSummary.summary}
                    onChange={(e) => {
                      setMeetSummary((val) => {
                        return { ...val, summary: e.target.value };
                      });
                    }}
                    onBlur={() => {
                      // Save logic when clicking outside the textarea
                      setMeetSummary((val) => {
                        return { ...val, editing: false };
                      });

                      let user = getCurrentUser();
                      partialUpdateUserCalendarMeetings(user.uid, data.id, { summary: meetSummary.summary },
                        (response) => {
                          const newCalSum = calendarMeetings;
                          newCalSum[idx] = {
                            ...newCalSum[idx],
                            summary: meetSummary.summary,
                          };
                          import("../../redux/actions/meetingsActions")
                            .then((ac) =>
                              dispatch(ac.setCalendarMeetings(newCalSum))
                            )
                            .then(() => {
                              toast.success("Summary Saved");
                            });
                        },
                        (error) => {
                            console.log("error: ", error);
                        }
                      );
                    }}
                    className="bg-slate-200 outline-none"
                    style={{
                      width: "100%",
                      minHeight: "50px", // Define a minimum height
                      boxSizing: "border-box",
                    }}
                    rows={1}
                    placeholder="Edit Call Summary"
                    // onFocus={() => setFocusTextarea(true)}
                  />
                ) : (
                  <div
                    onDoubleClick={handleDoubleClick}
                    className={`text-sm 2xl:text-base transition`}
                  >
                    {data?.transliterationAvailable && transliteration
                      ? highlightText(data?.transSummary, searchTerm)
                      : highlightText(data?.summary, searchTerm)}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <div
          className={`flex flex-wrap p-[10px] sm:p-[20px] mx-auto ${
            !(
              data?.notes?.length > 0 ||
              data?.tasks?.length > 0 ||
              data?.questions?.length > 0 ||
              data?.tasksForOthers?.length > 0
            ) && "hidden"
          }`}
        >
          {data?.notes?.length > 0 && !showEdit && (
            <ul className="list-disc md:w-[50%] p-[10px] sm:p-[20px] bg-[#fafefe] relative">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#ddf8f9]"></div>
              <div className="3xl:text-xl text-[18px] font-bold text-[#212121]">
                Important Notes
              </div>
              <div className="h-[200px] overflow-auto">
                {data &&
                  data.notes.map((item, index) => {
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={index}
                      >
                        <input
                          onChange={async() => {
                            const newNotes = data.notes;
                            newNotes[index] = {
                              ...item,
                              completed: !item.completed,
                            };

                            let user = getCurrentUser();
                            await partialUpdateUserCalendarMeetings(user.uid, data.id, { notes: newNotes });
                            const newMeetData = calendarMeetings;
                            newMeetData[idx] = {
                              ...newMeetData[idx],
                              notes: newNotes,
                            };
                            import("../../redux/actions/meetingsActions").then(
                              (ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        <div
                          className={`text-sm 2xl:text-base ${
                            item.completed && "text-gray-300"
                          } transition`}
                        >
                          {data?.transliterationAvailable && transliteration
                            ? highlightText(item.transName, searchTerm)
                            : highlightText(item.name, searchTerm)}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}

          {/* IMPORTANT NOTES START  */}

          {data?.notes?.length > 0 && showEdit && (
            <ul className="list-disc md:w-[50%] p-[10px] sm:p-[20px] bg-[#fafefe] relative">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#ddf8f9]"></div>
              <div className="3xl:text-xl text-[18px] font-bold text-[#212121]">
                Important Notes
              </div>
              <div className="h-[200px] overflow-auto">
                {data &&
                  data.notes.map((item, index) => {
                    const noteState = meetNote[index] || {
                      name: item.name,
                      editing: false,
                    };
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={index}
                      >
                        <input
                          onChange={async() => {
                            const newNotes = data.notes;
                            newNotes[index] = {
                              ...newNotes[index],
                              completed: !item.completed,
                            };

                            let user = getCurrentUser();
                            await partialUpdateUserCalendarMeetings(user.uid, data.id, { notes: newNotes });
                            const newMeetData = calendarMeetings;
                            newMeetData[idx] = {
                              ...newMeetData[idx],
                              notes: newNotes,
                            };
                            import("../../redux/actions/meetingsActions").then(
                              (ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        {noteState.editing ? (
                          <textarea
                            value={noteState.name}
                            onChange={(e) => {
                              setMeetNote((prevMeetNote) => ({
                                ...prevMeetNote,
                                [index]: {
                                  ...prevMeetNote[index],
                                  name: e.target.value,
                                },
                              }));
                            }}
                            onBlur={async() => {
                              const newNotes = data.notes;
                              const trimmedContent = noteState.name.trim();

                              if (trimmedContent === "") {
                                // Content is empty, delete the bullet point
                                newNotes.splice(index, 1);
                              } else {
                                // Update the note content
                                newNotes[index] = {
                                  ...item,
                                  name: noteState.name,
                                };
                              }

                              let user = getCurrentUser();
                              await partialUpdateUserCalendarMeetings(user.uid, data.id, { notes: newNotes });
                              const newMeetData = calendarMeetings;
                              newMeetData[idx] = {
                                ...newMeetData[idx],
                                notes: newNotes,
                              };
                              import(
                                "../../redux/actions/meetingsActions"
                              ).then((ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                              );

                              setMeetNote((prevMeetNote) => ({
                                ...prevMeetNote,
                                [index]: {
                                  ...prevMeetNote[index],
                                  editing: false,
                                },
                              }));
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent the default behavior of the Enter key

                                if (e.target.value.trim() !== "") {
                                  // Ensure all previous edits are saved
                                  const newNotes = data.notes;
                                  newNotes[index] = {
                                    ...newNotes[index],
                                    name: noteState.name,
                                  };

                                  const newNote = {
                                    name: "",
                                    editing: true,
                                  };

                                  // Insert the new note after the current index
                                  newNotes.splice(index + 1, 0, newNote);

                                  setMeetNote((prevMeetNote) => ({
                                    ...prevMeetNote,
                                    [index + 1]: newNote,
                                  }));

                                  // Set a timeout to focus on the newly created input element
                                  setTimeout(() => {
                                    const inputElement =
                                      document.getElementById(
                                        `note-input-${index + 1}`
                                      );
                                    if (inputElement) {
                                      inputElement.focus();
                                    }
                                  }, 0);
                                  
                                  let user = getCurrentUser();
                                  partialUpdateUserCalendarMeetings(user.uid, data.id, { notes: newNotes },
                                    (response) => {
                                      const newMeetData = [...calendarMeetings];
                                      newMeetData[idx] = {
                                        ...newMeetData[idx],
                                        notes: newNotes,
                                      };
                                      import(
                                        "../../redux/actions/meetingsActions"
                                      ).then((ac) =>
                                        dispatch(
                                          ac.setCalendarMeetings(newMeetData)
                                        )
                                      );
                                    },
                                    (error) => {
                                        console.log("error: ", error);
                                    }
                                  );
                                }
                              }
                            }}
                            style={{
                              width: "100%",
                              minHeight: "20px",
                              boxSizing: "border-box",
                            }}
                            rows={1}
                            className="bg-slate-200 text-sm 2xl:text-base outline-none ml-[5px]"
                            id={`note-input-${index}`}
                          />
                        ) : (
                          <div
                            onDoubleClick={() =>
                              handleNoteDoubleClick(index, item)
                            }
                            className={`text-sm 2xl:text-base ${
                              item.completed && "text-gray-300"
                            } transition`}
                          >
                            {data?.transliterationAvailable && transliteration
                              ? highlightText(item.transName, searchTerm)
                              : highlightText(item.name, searchTerm)}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}

          {/* IMPORTANT NOTES END */}

          {data?.tasks?.length > 0 && !showEdit && (
            <ul className="list-disc md:w-[50%] p-[10px] sm:p-[20px] bg-[#f8fef6] relative  ">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#c4f7b6]"></div>
              <div className="3xl:text-xl text-[18px] font-bold text-[#212121]">
                Assigned to me
              </div>
              <div className="h-[200px] overflow-auto">
                {data &&
                  data.tasks.map((item, index) => {
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={index}
                      >
                        <input
                          onChange={async() => {
                            const newTasks = data.tasks;
                            newTasks[index] = {
                              ...newTasks[index],
                              completed: !item.completed,
                            };

                            let user = getCurrentUser();
                            await partialUpdateUserCalendarMeetings(user.uid, data.id, { tasks: newTasks });
                            const newMeetData = calendarMeetings;
                            newMeetData[idx] = {
                              ...newMeetData[idx],
                              tasks: newTasks,
                            };
                            import("../../redux/actions/meetingsActions").then(
                              (ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        <div
                          className={`text-sm 2xl:text-base ${
                            item.completed && "text-gray-300"
                          } transition`}
                        >
                          {data?.transliterationAvailable && transliteration
                            ? highlightText(item.transName, searchTerm)
                            : highlightText(item.name, searchTerm)}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}

          {/* NEW ASSIGNMENT TO ME START */}

          {data?.tasks?.length > 0 && showEdit && (
            <ul className="list-disc md:w-[50%] p-[10px] sm:p-[20px] bg-[#f8fef6] relative">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#c4f7b6]"></div>
              <div className="3xl:text-xl text-[18px] font-bold text-[#212121]">
                Assigned to me
              </div>
              <div className="h-[200px] overflow-auto">
                {data &&
                  data.tasks.map((item, index) => {
                    const taskState = meetTask[index] || {
                      name: item.name,
                      editing: false,
                    };

                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={index}
                      >
                        <input
                          onChange={() => {
                            const newTasks = data.tasks;
                            newTasks[index] = {
                              ...newTasks[index],
                              completed: !item.completed,
                            };

                            let user = getCurrentUser();
                            partialUpdateUserCalendarMeetings(user.uid, data.id, { tasks: newTasks },
                              (response) => {
                                const newMeetData = [...calendarMeetings];
                                newMeetData[idx] = {
                                  ...newMeetData[idx],
                                  tasks: newTasks,
                                };
                                import(
                                  "../../redux/actions/meetingsActions"
                                ).then((ac) =>
                                  dispatch(ac.setCalendarMeetings(newMeetData))
                                );
                              }
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        {taskState.editing ? (
                          <textarea
                            value={taskState.name}
                            onChange={(e) => {
                              setMeetTask((prevMeetTask) => ({
                                ...prevMeetTask,
                                [index]: {
                                  ...prevMeetTask[index],
                                  name: e.target.value,
                                },
                              }));
                            }}
                            onBlur={() => {
                              const newTasks = data.tasks;
                              const trimmedContent = taskState.name.trim();

                              if (trimmedContent === "") {
                                // Content is empty, delete the bullet point
                                newTasks.splice(index, 1);
                              } else {
                                // Update the task content
                                newTasks[index] = {
                                  ...item,
                                  name: taskState.name,
                                };
                              }

                              let user = getCurrentUser();
                              partialUpdateUserCalendarMeetings(user.uid, data.id, { tasks: newTasks },
                                (response) => {
                                  const newMeetData = [...calendarMeetings];
                                  newMeetData[idx] = {
                                    ...newMeetData[idx],
                                    tasks: newTasks,
                                  };
                                  import(
                                    "../../redux/actions/meetingsActions"
                                  ).then((ac) =>
                                    dispatch(ac.setCalendarMeetings(newMeetData))
                                  );
                                }
                              );

                              setMeetTask((prevMeetTask) => ({
                                ...prevMeetTask,
                                [index]: {
                                  ...prevMeetTask[index],
                                  editing: false,
                                },
                              }));
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent the default behavior of the Enter key

                                if (e.target.value.trim() !== "") {
                                  // Ensure all previous edits are saved
                                  const newTasks = data.tasks;
                                  newTasks[index] = {
                                    ...newTasks[index],
                                    name: taskState.name,
                                  };

                                  const newTask = {
                                    name: "",
                                    editing: true,
                                  };

                                  // Insert the new task after the current index
                                  newTasks.splice(index + 1, 0, newTask);

                                  setMeetTask((prevMeetTask) => ({
                                    ...prevMeetTask,
                                    [index + 1]: newTask,
                                  }));

                                  // Set a timeout to focus on the newly created input element
                                  setTimeout(() => {
                                    const inputElement =
                                      document.getElementById(
                                        `task-input-${index + 1}`
                                      );
                                    if (inputElement) {
                                      inputElement.focus();
                                    }
                                  }, 0);
                                  
                                  let user = getCurrentUser();
                                  partialUpdateUserCalendarMeetings(user.uid, data.id, { tasks: newTasks },
                                    (response) => {
                                      const newMeetData = [...calendarMeetings];
                                      newMeetData[idx] = {
                                        ...newMeetData[idx],
                                        tasks: newTasks,
                                      };
                                      import(
                                        "../../redux/actions/meetingsActions"
                                      ).then((ac) =>
                                        dispatch(
                                          ac.setCalendarMeetings(newMeetData)
                                        )
                                      );
                                    }
                                  );
                                }
                              }
                            }}
                            style={{
                              width: "100%",
                              minHeight: "20px",
                              boxSizing: "border-box",
                            }}
                            rows={1}
                            className="bg-slate-200 text-sm 2xl:text-base outline-none ml-[5px]"
                            id={`task-input-${index}`}
                          />
                        ) : (
                          <div
                            onDoubleClick={() =>
                              handleTaskDoubleClick(index, item)
                            }
                            className={`text-sm 2xl:text-base ${
                              item.completed && "text-gray-300"
                            } transition`}
                          >
                            {data?.transliterationAvailable && transliteration
                              ? highlightText(item.transName, searchTerm)
                              : highlightText(item.name, searchTerm)}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}

          {/* NEW ASSIGNMENT TO ME END */}

          {data?.questions?.length > 0 && !showEdit && (
            <ul className="list-disc md:w-[50%] p-[10px] sm:p-[20px] bg-[#fefef9] relative ">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#f9f8cb]"></div>
              <div className="3xl:text-xl text-[18px] font-bold text-[#212121]">
                Questions
              </div>
              <div className="h-[200px] overflow-auto">
                {data &&
                  data?.questions.map((item, index) => {
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={index}
                      >
                        <input
                          onChange={async() => {
                            const newQuestions = data?.questions;
                            newQuestions[index] = {
                              ...item,
                              completed: !item.completed,
                            };

                            let user = getCurrentUser();
                            await partialUpdateUserCalendarMeetings(user.uid, data.id, { questions: newQuestions });
                            const newMeetData = calendarMeetings;
                            newMeetData[idx] = {
                              ...newMeetData[idx],
                              questions: newQuestions,
                            };
                            import("../../redux/actions/meetingsActions").then(
                              (ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        <div
                          className={`text-sm 2xl:text-base ${
                            item.completed && "text-gray-300"
                          } transition`}
                        >
                          {data?.transliterationAvailable && transliteration
                            ? highlightText(item.transName, searchTerm)
                            : highlightText(item.name, searchTerm)}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}

          {/* New Question Start */}

          {data?.questions?.length > 0 && showEdit && (
            <ul className="list-disc md:w-[50%] p-[10px] sm:p-[20px] bg-[#fefef9] relative ">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#f9f8cb]"></div>
              <div className="3xl:text-xl text-[18px] font-bold text-[#212121]">
                Questions
              </div>
              <div className="h-[200px] overflow-auto">
                {data &&
                  data?.questions.map((item, index) => {
                    const questionState = meetQuestion[index] || {
                      name: item.name,
                      editing: false,
                    };

                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={index}
                      >
                        <input
                          onChange={async() => {
                            const newQuestions = [...data.questions];
                            newQuestions[index] = {
                              ...item,
                              completed: !item.completed,
                            };

                            let user = getCurrentUser();
                            await partialUpdateUserCalendarMeetings(user.uid, data.id, { questions: newQuestions });
                            
                            const newMeetData = calendarMeetings;
                            newMeetData[idx] = {
                              ...newMeetData[idx],
                              questions: newQuestions,
                            };
                            import("../../redux/actions/meetingsActions").then(
                              (ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        {questionState.editing ? (
                          <textarea
                            value={questionState.name}
                            onChange={(e) => {
                              setMeetQuestion((prevMeetQuestion) => ({
                                ...prevMeetQuestion,
                                [index]: {
                                  ...prevMeetQuestion[index],
                                  name: e.target.value,
                                },
                              }));
                            }}
                            onBlur={async() => {
                              const newQuestions = data.questions;
                              const trimmedContent = questionState.name.trim();

                              if (trimmedContent === "") {
                                // Content is empty, delete the question
                                newQuestions.splice(index, 1);
                              } else {
                                // Update the question content
                                newQuestions[index] = {
                                  ...item,
                                  name: questionState.name,
                                };
                              }
                              
                              let user = getCurrentUser();
                              await partialUpdateUserCalendarMeetings(user.uid, data.id, { questions: newQuestions });

                              const newMeetData = calendarMeetings;
                              newMeetData[idx] = {
                                ...newMeetData[idx],
                                questions: newQuestions,
                              };
                              import(
                                "../../redux/actions/meetingsActions"
                              ).then((ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                              );

                              setMeetQuestion((prevMeetQuestion) => ({
                                ...prevMeetQuestion,
                                [index]: {
                                  ...prevMeetQuestion[index],
                                  editing: false,
                                },
                              }));
                            }}
                            onKeyDown={async(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent the default behavior of the Enter key

                                if (e.target.value.trim() !== "") {
                                  // Ensure all previous edits are saved
                                  const newQuestions = data.questions;
                                  newQuestions[index] = {
                                    ...newQuestions[index],
                                    name: questionState.name,
                                  };

                                  const newQuestion = {
                                    name: "",
                                    editing: true,
                                  };

                                  // Insert the new question after the current index
                                  newQuestions.splice(
                                    index + 1,
                                    0,
                                    newQuestion
                                  );

                                  setMeetQuestion((prevMeetQuestion) => ({
                                    ...prevMeetQuestion,
                                    [index + 1]: newQuestion,
                                  }));

                                  // Set a timeout to focus on the newly created input element
                                  setTimeout(() => {
                                    const inputElement =
                                      document.getElementById(
                                        `question-input-${index + 1}`
                                      );
                                    if (inputElement) {
                                      inputElement.focus();
                                    }
                                  }, 0);
                                  
                                  let user = getCurrentUser();
                                  await partialUpdateUserCalendarMeetings(user.uid, data.id, { questions: newQuestions },
                                    (response) => {
                                      const newMeetData = [...calendarMeetings];
                                      newMeetData[idx] = {
                                        ...newMeetData[idx],
                                        questions: newQuestions,
                                      };
                                      import(
                                        "../../redux/actions/meetingsActions"
                                      ).then((ac) =>
                                        dispatch(
                                          ac.setCalendarMeetings(newMeetData)
                                        )
                                      );
                                    }
                                  );
                                }
                              }
                            }}
                            style={{
                              width: "100%", // Take the full width of the container
                              minHeight: "20px",
                              boxSizing: "border-box", // Include padding and border in the width
                            }}
                            rows={1}
                            className="bg-slate-200 text-sm 2xl:text-base outline-none ml-[5px]"
                            id={`question-input-${index}`}
                          />
                        ) : (
                          <div
                            onDoubleClick={() =>
                              handleQuestionDoubleClick(index, item)
                            }
                            className={`text-sm 2xl:text-base ${
                              item.completed && "text-gray-300"
                            } transition`}
                          >
                            {data?.transliterationAvailable && transliteration
                              ? highlightText(item.transName, searchTerm)
                              : highlightText(item.name, searchTerm)}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}

          {/* New Question END */}

          {data?.tasksForOthers?.length > 0 && !showEdit && (
            <ul className="list-disc md:w-[50%] p-[10px] sm:p-[20px] bg-[#fffaf4] relative  ">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#ffddac]"></div>
              <div className="3xl:text-xl text-[18px] font-bold text-[#212121]">
                Assigned to Others
              </div>
              <div className="h-[200px] overflow-auto">
                {data &&
                  data?.tasksForOthers.map((item, index) => {
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={index}
                      >
                        <input
                          onChange={async() => {
                            const tfo = data.tasksForOthers;
                            tfo[index] = {
                              ...item,
                              completed: !item.completed,
                            };

                            let user = getCurrentUser();
                            await partialUpdateUserCalendarMeetings(user.uid, data.id, { tasksForOthers: tfo });
                            
                            const newMeetData = calendarMeetings;
                            newMeetData[idx] = {
                              ...newMeetData[idx],
                              tasksForOthers: tfo,
                            };
                            import("../../redux/actions/meetingsActions").then(
                              (ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        <div
                          className={`text-sm 2xl:text-base ${
                            item.completed && "text-gray-300"
                          } transition`}
                        >
                          {data?.transliterationAvailable && transliteration
                            ? highlightText(item.transName, searchTerm)
                            : highlightText(item.name, searchTerm)}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}

          {/* NEW ASSIGNED TO OTHERS START */}

          {data?.tasksForOthers?.length > 0 && showEdit && (
            <ul className="list-disc md:w-[50%] p-[10px] sm:p-[20px] bg-[#fffaf4] relative">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#ffddac]"></div>
              <div className="3xl:text-xl text-[18px] font-bold text-[#212121]">
                Assigned to Others
              </div>
              <div className="h-[200px] overflow-auto">
                {data &&
                  data.tasksForOthers.map((item, index) => {
                    const taskForOthersState = meetTaskForOthers[index] || {
                      name: item.name,
                      editing: false,
                    };

                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={index}
                      >
                        <input
                          onChange={async() => {
                            const newTasksForOthers = data.tasksForOthers;
                            newTasksForOthers[index] = {
                              ...newTasksForOthers[index],
                              completed: !item.completed,
                            };

                            let user = getCurrentUser();
                            await partialUpdateUserCalendarMeetings(user.uid, data.id, { tasksForOthers: newTasksForOthers });
                            
                            const newMeetData = calendarMeetings;
                            newMeetData[idx] = {
                              ...newMeetData[idx],
                              tasksForOthers: newTasksForOthers,
                            };
                            import("../../redux/actions/meetingsActions").then(
                              (ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        {taskForOthersState.editing ? (
                          <textarea
                            value={taskForOthersState.name}
                            onChange={(e) => {
                              setMeetTaskForOthers((prevMeetTaskForOthers) => ({
                                ...prevMeetTaskForOthers,
                                [index]: {
                                  ...prevMeetTaskForOthers[index],
                                  name: e.target.value,
                                },
                              }));
                            }}
                            onBlur={() => {
                              const newTasksForOthers = data.tasksForOthers;
                              const trimmedContent =
                                taskForOthersState.name.trim();

                              if (trimmedContent === "") {
                                // Content is empty, delete the bullet point
                                newTasksForOthers.splice(index, 1);
                              } else {
                                // Update the task content
                                newTasksForOthers[index] = {
                                  ...item,
                                  name: taskForOthersState.name,
                                };
                              }

                              let user = getCurrentUser();
                              partialUpdateUserCalendarMeetings(user.uid, data.id, { tasksForOthers: newTasksForOthers });

                              const newMeetData = calendarMeetings;
                              newMeetData[idx] = {
                                ...newMeetData[idx],
                                tasksForOthers: newTasksForOthers,
                              };
                              import(
                                "../../redux/actions/meetingsActions"
                              ).then((ac) =>
                                dispatch(ac.setCalendarMeetings(newMeetData))
                              );

                              setMeetTaskForOthers((prevMeetTaskForOthers) => ({
                                ...prevMeetTaskForOthers,
                                [index]: {
                                  ...prevMeetTaskForOthers[index],
                                  editing: false,
                                },
                              }));
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // Prevent the default behavior of the Enter key

                                if (e.target.value.trim() !== "") {
                                  // Ensure all previous edits are saved
                                  const newTasksForOthers = data.tasksForOthers;
                                  newTasksForOthers[index] = {
                                    ...newTasksForOthers[index],
                                    name: taskForOthersState.name,
                                  };

                                  const newTaskForOthers = {
                                    name: "",
                                    editing: true,
                                  };

                                  // Insert the new task after the current index
                                  newTasksForOthers.splice(
                                    index + 1,
                                    0,
                                    newTaskForOthers
                                  );

                                  setMeetTaskForOthers(
                                    (prevMeetTaskForOthers) => ({
                                      ...prevMeetTaskForOthers,
                                      [index + 1]: newTaskForOthers,
                                    })
                                  );

                                  // Set a timeout to focus on the newly created input element
                                  setTimeout(() => {
                                    const inputElement =
                                      document.getElementById(
                                        `taskForOthers-input-${index + 1}`
                                      );
                                    if (inputElement) {
                                      inputElement.focus();
                                    }
                                  }, 0);
                                  
                                  let user = getCurrentUser();
                                  partialUpdateUserCalendarMeetings(user.uid, data.id, { tasksForOthers: newTasksForOthers },
                                    (response) => {
                                      const newMeetData = [...calendarMeetings];
                                      newMeetData[idx] = {
                                        ...newMeetData[idx],
                                        tasksForOthers: newTasksForOthers,
                                      };
                                      import(
                                        "../../redux/actions/meetingsActions"
                                      ).then((ac) =>
                                        dispatch(
                                          ac.setCalendarMeetings(newMeetData)
                                        )
                                      );
                                    }
                                  );
                                }
                              }
                            }}
                            style={{
                              width: "100%",
                              minHeight: "20px",
                              boxSizing: "border-box",
                            }}
                            rows={1}
                            className="bg-slate-200 text-sm 2xl:text-base outline-none ml-[5px]"
                            id={`taskForOthers-input-${index}`}
                          />
                        ) : (
                          <div
                            onDoubleClick={() =>
                              handleTaskForOthersDoubleClick(index, item)
                            }
                            className={`text-sm 2xl:text-base ${
                              item.completed && "text-gray-300"
                            } transition`}
                          >
                            {data?.transliterationAvailable && transliteration
                              ? highlightText(item.transName, searchTerm)
                              : highlightText(item.name, searchTerm)}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}

          {/* NEW ASSIGNED TO OTHERS END */}
        </div>
        {data?.summary && (
          <div className=" text-[#6b7b8a] px-[10px] sm:px-[20px] ">
            <div className="my-[10px]">
              created:{" "}
              {moment(moment(data?.createdAt)?.toDate()).format("MMM DD, YYYY")}
            </div>
            {open && (
              <div className=" my-[10px] flex items-center gap-[5px] s16-step">
                Rate the above Summary?
                {[1, 2, 3, 4, 5].map((x, index) => {
                  return (
                    <AiFillStar
                      onMouseEnter={() => {
                        setStar(x);
                      }}
                      onMouseLeave={() => {
                        setStar(0);
                      }}
                      onClick={() => {
                        setRating(x);

                        let user = getCurrentUser();
                        partialUpdateUserCalendarMeetings(user.uid, data.id, { rating: x });

                        const newMeetData = calendarMeetings;
                        newMeetData[idx] = { ...newMeetData[idx], rating: x };
                        import("../../redux/actions/meetingsActions").then(
                          (ac) => dispatch(ac.setCalendarMeetings(newMeetData))
                        );
                      }}
                      key={x}
                      className={`transitionFast cursor-pointer ${
                        x <= star || x <= rating
                          ? "text-yellow-400"
                          : "text-gray-300"
                      }`}
                    />
                  );
                })}
              </div>
            )}
            {open && (
              <div
                onClick={() => {
                  setTranscriptOpen(!transcriptOpen);
                  setTranscriptEditing(false);
                  setShowFindReplace(false);
                  setFindText("");
                  setReplaceText("");
                }}
                className="s17-step flex items-center cursor-pointer my-[10px] gap-[10px]"
              >
                <div>
                  <AiOutlineFileSync />
                </div>
                <div className="font-semibold">
                  Transcript
                  {data?.fileDetails?.charLen &&
                    ` (${(
                      data?.fileDetails?.charLen || 0
                    ).toLocaleString()} characters)`}
                </div>
                <div>
                  <BiChevronRight
                    className={`${
                      transcriptOpen ? "rotate-90" : ""
                    } transition text-xl`}
                  />
                </div>
              </div>
            )}
            {/*Transcript Edit function*/}

            {/* {transcriptOpen && (
              <div className="p-[10px] rounded-md bg-gray-300 fade relative">
                {transcriptContent && (
                  <button
                    title="Copy to clipboard"
                    className="flex items-center justify-center px-4 py-2 bg-blue-900 text-white rounded hover:bg-blue-800  absolute top-[15px] right-[15px]"
                    onClick={() => {
                      navigator.clipboard.writeText(transcriptContent);
                      toast.success("Copied!");
                    }}
                  >
                    <RiClipboardLine />
                  </button>
                )}
                <pre className="text-sm whitespace-break-spaces text-gray-600 max-h-[400px] overflow-auto">
                  {transcriptContent
                    ? transcriptContent
                    : transcriptLoading
                    ? "Loading..."
                    : "No Transcript Available"}
                </pre>
              </div>
            )} */}

            {transcriptOpen && (
              <div className="p-[10px] rounded-md bg-gray-300 fade relative">
                <div className="flex items-center space-x-2 mb-2">
                  {transcriptContent && (
                    <>
                      {/* {!transcriptEditing && (
                        <button
                          title="Edit"
                          className="flex items-center justify-center px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-400"
                          onClick={() => {
                            setTranscriptEditing(true);
                            createNewTranscript();
                          }}
                        >
                          <BiEdit />
                        </button>
                      )} */}

                      {transcriptEditing && (
                        <>
                          <button
                            title="Search"
                            className="flex items-center justify-center px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400"
                            onClick={() => {
                              setShowFindReplace(true);
                            }}
                          >
                            <BiSearch />
                          </button>
                        </>
                      )}

                      {transcriptEditing && (
                        <button
                          title="Save"
                          className="flex items-center justify-center px-4 py-2 bg-green-500 text-white rounded hover:bg-green-400"
                          onClick={() => {
                            setShowFindReplace(false);
                            setTranscriptEditing(false);
                            handleSaveTranscript();
                          }}
                        >
                          <BiSave />
                        </button>
                      )}

                      <button
                        title="Copy to clipboard"
                        className="flex items-center justify-center px-4 py-2 bg-blue-900 text-white rounded hover:bg-blue-800"
                        onClick={() => {
                          navigator.clipboard.writeText(copyToClipboardRef.current.innerText);
                          toast.success("Copied!");
                        }}
                      >
                        <RiClipboardLine />
                      </button>
                    </>
                  )}

                  {showFindReplace && (
                    <div className="flex items-center space-x-2 mt-2">
                      <input
                        type="text"
                        value={findText}
                        onChange={(e) => setFindText(e.target.value)}
                        placeholder="Find"
                        className="border p-1"
                      />
                      <input
                        type="text"
                        value={replaceText}
                        onChange={(e) => setReplaceText(e.target.value)}
                        placeholder="Replace"
                        className="border p-1"
                      />
                      <button
                        title="Replace All"
                        className="flex items-center justify-center px-4 py-2 bg-red-500 text-white rounded hover:bg-red-400"
                        onClick={() => {
                          handleReplaceAll();
                          setShowFindReplace(false);
                          setTranscriptEditing(true);
                        }}
                      >
                        Replace All
                      </button>
                      <button
                        title="Cancel"
                        className="flex items-center justify-center px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-400"
                        onClick={() => {
                          setShowFindReplace(false);
                          setTranscriptEditing(true);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>

                <div className="text-sm whitespace-break-spaces text-gray-600 max-h-[400px] overflow-auto border border-gray-400 p-2" ref={copyToClipboardRef}>
                  {showFindReplace === false && transcriptEditing ? (
                    <div>
                      {transcriptContent.map((message, messageIndex) => (
                        <div key={messageIndex} className="mb-2">
                          <strong className="text-[#07457f]">
                            [{message.timeStamp}] {message.participant}:
                          </strong>
                          {currentMessage === messageIndex ? (
                            <textarea
                              value={message.text}
                              onChange={(e) =>
                                handleTextareaChange(
                                  messageIndex,
                                  e.target.value
                                )
                              }
                              className="bg-slate-200 outline-none"
                              style={{
                                width: "100%",
                                minHeight: "25px",
                                boxSizing: "border-box",
                                resize: "none",
                              }}
                              rows={1}
                              ref={(input) => {
                                if (input) {
                                  input.style.height = "auto";
                                  input.style.height =
                                    input.scrollHeight + "px";
                                }
                              }}
                              onInput={(e) => {
                                e.target.style.height = "auto";
                                e.target.style.height =
                                  e.target.scrollHeight + "px";
                              }}
                            />
                          ) : (
                            <div
                              onClick={() => {
                                setCurrentMessage(messageIndex);
                              }}
                            >
                              {message.text}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : transcriptContent ? (
                    <div>
                      {transcriptContent.map((message, messageIndex) => (
                        <div key={messageIndex} className="mb-2">
                          <strong className="text-[#07457f]">
                            [{message.timeStamp}]{" "}
                            {highlightTranscript(
                              message.participant,
                              (searchTerm && findText) || searchTerm || findText
                            )}
                            :
                          </strong>
                          <div>
                            {highlightTranscript(
                              message.text,
                              (searchTerm && findText) || searchTerm || findText
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : transcriptLoading ? (
                    "Loading..."
                  ) : (
                    "No Transcript Available"
                  )}
                </div>
              </div>
            )}

            {/*Add code to display video*/}
            {data && (
              <div className="relative">
                <div
                  onClick={async () => {
                    const url = await handleVideoButtonClick(data?.botId);
                    if (url) {
                      setVideoUrl(url);
                      setVideoOpen(!videoOpen);
                    } else {
                      console.error("No video URL present");
                      toast.error("No Video Available");
                    }
                  }}
                  className="flex items-center cursor-pointer my-[10px] gap-[10px]"
                >
                  <div>
                    <AiOutlineFileSync />
                  </div>
                  <div className="font-semibold">Video</div>
                  <div>
                    <BiChevronRight
                      className={`${
                        videoOpen ? "rotate-90" : ""
                      } transition text-xl`}
                    />
                  </div>
                </div>

                {videoOpen && (
                  <div className={`w-full bg-[#f1f3f4] auto`}>
                    {videoUrl ? (
                      <ReactPlayer
                        ref={audioPlayerRef}
                        url={videoUrl}
                        controls
                        width={"100%"}
                        height={"auto"}
                      />
                    ) : (
                      <div>No Video present</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      {!pastMeeting && (
        <div className="flex gap-[10px] items-center flex-wrap">
          {data?.meetingPlatform === "google_meet" && (
            <div
              onClick={() => {
                window.open(
                  `https://meet.google.com/${data?.meetInvite?.meetId}`
                );
              }}
              className="cursor-pointer w-[30px] hover:scale-150 transition"
            >
              <img src={gmeet} alt="GMeet" />
            </div>
          )}
          <div className="flex items-center gap-[10px] text-xs sm:text-sm 2xl:text-base">
            Summarize this meet:
            <div
              onClick={() => {
                setWillRecord(true);
                updateRecordingStatus({
                  user_id: localStorage.getItem("@auth"),
                  calendar_meeting_id: data.calendarMeetId,
                  override_should_record: "true",
                });

                let user = getCurrentUser();
                partialUpdateUserCalendarMeetings(user.uid, data.id, { willRecord: true });

                const newCalData = calendarMeetings;
                newCalData[idx] = { ...newCalData[idx], willRecord: true };
                import("../../redux/actions/meetingsActions").then((ac) =>
                  dispatch(ac.setCalendarMeetings(newCalData))
                );
              }}
              className={`px-[15px] py-[5px] border rounded-md cursor-pointer ${
                willRecord ? "text-blue-500 border-blue-500" : ""
              }`}
            >
              Yes
            </div>
            <div
              onClick={() => {
                setWillRecord(false);
                updateRecordingStatus({
                  user_id: localStorage.getItem("@auth"),
                  calendar_meeting_id: data.calendarMeetId,
                  override_should_record: "false",
                });

                let user = getCurrentUser();
                partialUpdateUserCalendarMeetings(user.uid, data.id, { willRecord: false });

                const newCalData = calendarMeetings;
                newCalData[idx] = { ...newCalData[idx], willRecord: false };
                import("../../redux/actions/meetingsActions").then((ac) =>
                  dispatch(ac.setCalendarMeetings(newCalData))
                );
              }}
              className={`px-[15px] py-[5px] border rounded-md cursor-pointer ${
                willRecord ? "" : "text-red-500 border-red-500"
              }`}
            >
              No
            </div>
          </div>
        </div>
      )}
      {pastMeeting && (
        <div className="flex gap-[10px] mt-[10px] text-xs sm:text-sm 2xl:text-base">
          {data?.botStatus?.status !== "done" && !data?.summary && (
            <button
              onClick={() => {
                if (data?.botId) {
                  setBotStatus(data);
                } else if (data?.willRecord === false) {
                  toast.info("The meeting wasn't recorded");
                } else {
                  toast.info("Kindly refresh calendar meetings!");
                }
              }}
              className="shadow-sm fade hover:text-white py-[5px] px-[10px] border rounded-md transition hover:border-[#07457f] hover:bg-[#07457f]"
            >
              Check Status
            </button>
          )}
          {data?.botStatus?.status === "done" &&
            !(
              data?.summary ||
              data?.notes?.length ||
              data?.tasks?.length ||
              data?.tasksForOthers?.length ||
              data?.questions?.length
            ) && (
              <button
                onClick={() => {
                  setLanguage(userData?.defaultLanguage || "english");
                }}
                className="shadow-sm fade hover:text-white py-[5px] px-[10px]  border rounded-md transition hover:border-[#07457f] hover:bg-[#07457f]"
              >
                Generate Insights
              </button>
            )}
          <div>
            {(data?.summary ||
              data?.notes.length > 0 ||
              data?.tasks.length > 0 ||
              data?.tasksForOthers.length > 0 ||
              data?.questions.length > 0) && (
              <div
                className="s18-step shadow-sm fade text-white py-[5px] px-[10px] cursor-pointer rounded-md transition bg-[#07457f]"
                onClick={() => {
                  setSendMailModal(true);
                }}
              >
                Send notes
              </div>
            )}
          </div>
          <div className="flex flex-col">
            {showReProcess &&
              showEdit &&
              (data.url || data.generatedTranscript) && (
                <div className="shadow-sm fade text-white py-[5px] px-[10px] cursor-pointer rounded-md transition bg-[#07457f]">
                  {/* Re-Process Button */}
                  <div
                    onClick={() => {
                      handleSummarizeUsingTranscription(
                        data?.generatedTranscript
                      );
                    }}
                  >
                    {loading ? (
                      <CircularProgress
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "white",
                        }}
                      />
                    ) : (
                      "Re-Process"
                    )}
                  </div>
                </div>
              )}
          </div>
          <div
            onClick={() => {
              setLoading(false);
              setConfirmDelete(true);
            }}
          >
            <button className="s20-step text-red-500 transition fade rounded-md py-[5px] px-[10px] ">
              Delete
            </button>
          </div>

          {/* {showDropdown && (
            <div>
              <select
                value={language}
                onChange={(e) => {
                  setLanguage(e.target.value);
                }}
                name="language"
                className="outline-none"
                id=""
              >
                <option value="english">English</option>
                <option value="arabic">Arabic</option>
                <option value="dutch">Dutch</option>
                <option value="french">French</option>
                <option value="german">German</option>
                <option value="hindi">Hindi</option>
                <option value="italian">Italian</option>
                <option value="japanese">Japanese</option>
                <option value="portuguese">Portuguese</option>
                <option value="spanish">Spanish</option>
                <option value="multiLang">Multi Lingual (EN/AR/HI/UR)</option>
                <option className="cursor-not-allowed" disabled value="tamil">
                  Tamil
                </option>
              </select>
            </div>
          )} */}
        </div>
      )}
      {confirmDelete && (
        <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-40 justify-center items-center">
          <div className="w-fit flex flex-col items-end modalAnimation max-w-[85%]">
            <div
              onClick={() => {
                setConfirmDelete(false);
              }}
              className="bg-white cursor-pointer z-30 mb-[10px] w-fit rounded-full p-[2px]"
            >
              <IoClose />
            </div>
            <div
              className={`rounded-md bg-white border-box relative p-[15px] max-h-[85vh] text-sm sm:text-base w-[300px] overflow-auto overflow-x-hidden`}
            >
              <div className="">Are you sure you want to delete it?</div>
              <button
                onClick={() => {
                  setConfirmDelete(false);
                  document
                    .getElementById(data?.id)
                    .classList.add("deleteAnimation");
                  deleteThisMeetAndDuplicates().then(() => {
                    fetchTabMeetings();
                  });
                }}
                className="py-[5px] w-fit px-[20px] mt-[10px] float-right bg-red-500 text-white rounded-md flex items-center justify-center"
              >
                {!loading ? (
                  "Yes"
                ) : (
                  <CircularProgress
                    style={{ width: "20px", height: "20px", color: "white" }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* New Code Starts */}
      {!data?.summary && language && (
        <div className="fade">
          <div>
            Select Language (<b className="font-medium">Choose carefully</b>)
          </div>
          <select
            value={language}
            onChange={(e) => {
              setLanguage(e.target.value);
            }}
            name="language"
            className="outline-none"
            id=""
          >
            {Object.entries(languageOptions).map(([value, optionText]) => (
              <option
                key={value}
                value={value}
                disabled={!languagesArray.includes(value)}
              >
                {optionText}
              </option>
            ))}
          </select>
          <Button
            onClick={() => {
              handleTranscribeAndSummarize();
            }}
            children={
              loading ? (
                <CircularProgress
                  style={{ width: "20px", height: "20px", color: "white" }}
                />
              ) : (
                "Submit"
              )
            }
            className={"px-[10px] py-[5px] w-fit my-[5px] text-sm"}
          />
        </div>
      )}

      {/* New COde Ends */}
      {transcriptModal && (
        <TranscriptModal
          content={
            transcriptLoading ? (
              <div
                className={`fade w-full h-full flex flex-col items-center justify-center`}
              >
                <img src={cube} alt="" />
                <div className="text-xs">Loading...</div>
              </div>
            ) : (
              transcriptContent
            )
          }
          closeModal={() => {
            setTranscriptModal(false);
          }}
        />
      )}
      {sendMailModal && (
        <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-40 justify-center items-center ">
          <div className="w-fit flex flex-col items-end modalAnimation max-w-[85%]">
            <div
              onClick={() => {
                setSendMailModal(false);
              }}
              className="s19-2-step bg-white cursor-pointer z-30 mb-[10px] w-fit rounded-full p-[2px]"
            >
              <IoClose />
            </div>
            <div
              className={`rounded-md bg-white border-box relative p-[15px] max-h-[85vh] text-sm sm:text-base w-[500px] max-w-full overflow-auto overflow-x-hidden`}
            >
              <div className="font-medium text-sm sm:text-base xl:text-lg">
                Who is/are the intended recipient(s) of these notes?
              </div>
              <div
                className="s19-step border rounded-md p-[5px] mt-[10px] sm:p-[10px] flex items-center gap-[10px]"
                title="Emails"
              >
                <IoMail style={{ color: theme.color }} />
                <input
                  type="text"
                  name=""
                  id=""
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-grow outline-none rounded-md"
                  placeholder="Enter email(s)"
                />
              </div>
              <div className="sm:text-xs text-[8px] leading-[10px] mb-[10px]">
                You can enter multiple emails. Emails should be comma-separated,
                otherwise it won't be sent.
              </div>
              <div
                className="border rounded-md p-[5px] my-[10px] sm:p-[10px] flex items-center gap-[10px]"
                title="Meet Name"
              >
                <FaUsers style={{ color: theme.color }} />
                <input
                  type="text"
                  name=""
                  id=""
                  value={meetName.name}
                  onChange={(e) =>
                    setMeetName((meetName) => {
                      return { ...meetName, name: e.target.value };
                    })
                  }
                  className="flex-grow outline-none rounded-md"
                  placeholder="Enter meet name"
                />
              </div>
              <div
                className="shadow-sm fade flex items-center justify-center text-white py-[5px] px-[10px] w-fit cursor-pointer rounded-md transition bg-[#07457f]"
                onClick={() => {
                  if (!isValidEmailList(email)) {
                    toast.error("Enter email(s) in valid format");
                  } else {
                    setLoading(true);
                    sendNotesByEmail(
                      data.id,
                      "calendarMeetings",
                      email
                    )
                      .then((res) => {
                        console.log(res);
                        toast.success("Mail Sent");
                      })
                      .catch((err) => {
                        toast.error("Some error occured!");
                        console.log(err, "error");
                      })
                      .finally(() => {
                        setLoading(false);
                        setSendMailModal(false);
                      });
                  }
                }}
              >
                {loading ? (
                  <CircularProgress
                    style={{ width: "20px", height: "20px", color: "white" }}
                  />
                ) : (
                  "Send"
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarMeetingCard;
